import React from "react";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import FacebookIcon from "../../../../shared/components/Icons/FacebookIcon";


const LoginWithFacebook = (props) => {
  const responseFacebook = (response) => {
    const accessToken = response.accessToken;
    accessToken && props.onLoginWithFacebookClick({ accessToken: accessToken });
  };
  return (
    <FacebookLogin
      appId={process.env.REACT_APP_FACEBOOK_CLIENT_ID}
      callback={responseFacebook}
      reAuthenticate={true}
      authType="reauthenticate"
      render={(renderProps) => (
        <div className="account__btns ml-0" onClick={renderProps.onClick}>
          <div className="account__btn oaut-fb-btn mb-0 p-0 facebook-button-class">
            <FacebookIcon />
            <p className="d-flex align-items-center facebook-button-class">
              sign in with facebook
            </p>
          </div>
        </div>
      )}
    />
  );
};

export default LoginWithFacebook;